export const capitalizeFirstLetter = (name: string) =>
  name ? `${name[0].toUpperCase()}${name.slice(1)}` : '';
